import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ISlotsState } from "@/app_redux/reducers/slices/auth/slots_slice";
import SlotUserDetailsComponent from "../SlotUserDetailsComponent";
import SlotsRescheduleDetailsComponent from "../SlotsRescheduleDetailsComponent";

const SlotsUserDetailsHeaderComponent = () => {
  const { getRouteKey } = useRouter();
  const { rescheduleFlag } = useRouteInfo(getRouteKey("SLOTS", "id")).routeState.state as ISlotsState;
  return rescheduleFlag ? <SlotsRescheduleDetailsComponent /> : <SlotUserDetailsComponent />;
};

export default SlotsUserDetailsHeaderComponent;
